import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useScrollAnimation } from "@/hooks/use-scroll-animation";
import { cn } from "@/lib/utils";

const BOOKING_URL = "/book";

export const RussianFinalCTA = ({ cityName }: { cityName: string }) => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });
  return (
    <section className="py-24 bg-primary text-primary-foreground relative overflow-hidden">
      <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full translate-y-1/2 -translate-x-1/2 blur-3xl" />
      <div ref={ref} className={cn("container relative z-10 text-center anim-scale-up", isVisible && "is-visible")}>
        <h2 className="text-3xl md:text-5xl font-bold mb-6">Нужна уборка дома в {cityName} сегодня? Получите мгновенную цену и забронируйте онлайн</h2>
        <p className="text-xl opacity-90 mb-10 max-w-2xl mx-auto">
          Забудьте о хлопотах. Выберите услугу и запланируйте уборку за считанные минуты.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="btn-pulse bg-primary-foreground text-primary hover:bg-primary-foreground/90 font-bold text-lg px-12 py-8 h-auto rounded-2xl shadow-xl group w-full sm:w-auto">
            <a href={BOOKING_URL}>Записаться на уборку <ArrowRight className="ml-2 h-6 w-6 group-hover:translate-x-1 transition-transform" /></a>
          </Button>
          <Button
            size="lg"
            variant="ghost"
            className="border-2 border-primary-foreground text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground font-bold text-lg px-12 py-8 h-auto rounded-2xl w-full sm:w-auto"
            onClick={(e) => {
              e.preventDefault();
              window.dispatchEvent(new CustomEvent("open-service-inclusions"));
            }}
          >
            Посмотреть, что включено
          </Button>
        </div>
        <p className="mt-8 text-[11px] opacity-70">
          By booking, you agree to our <a href="https://www.uplevelcleaning.com/terms-of-service" target="_blank" rel="noopener noreferrer" className="underline hover:text-white transition-colors">Terms of Service</a>, <a href="https://www.uplevelcleaning.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="underline hover:text-white transition-colors">Privacy Policy</a>, and <a href="https://www.uplevelcleaning.com/cleaning-policies" target="_blank" rel="noopener noreferrer" className="underline hover:text-white transition-colors">Cleaning Policies</a>.
        </p>
      </div>
    </section>
  );
};
